/* ============================================
   GOOD FORM STUDIOS — Theme JavaScript
   v6.0 — Final UX pass: scroll-reveal, smooth
   interactions, announcement dismiss
   ============================================ */

(function() {
  'use strict';

  /* ------------------------------------------
     Configuration
     ------------------------------------------ */
  var CONFIG = {
    scrollThreshold: 10,
    observerThreshold: 0.1,
    observerRootMargin: '0px 0px -40px 0px',
    addedConfirmationMs: 2000
  };

  var strings = (window.theme && window.theme.strings) || {};

  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------
     Mobile Menu Toggle
     ------------------------------------------ */
  function initMobileMenu() {
    var toggle = document.querySelector('.site-header__menu-toggle');
    var nav = document.querySelector('.site-header__nav');

    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      nav.classList.toggle('is-open');
      var isOpen = nav.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (!toggle.contains(e.target) && !nav.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ------------------------------------------
     Sticky header with scroll state
     ------------------------------------------ */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrolled = false;
    function checkScroll() {
      var shouldBeScrolled = window.scrollY > CONFIG.scrollThreshold;
      if (shouldBeScrolled !== scrolled) {
        scrolled = shouldBeScrolled;
        header.classList.toggle('is-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  }

  /* ------------------------------------------
     Announcement Bar Dismiss
     ------------------------------------------ */
  function initAnnouncementDismiss() {
    var bar = document.querySelector('.announcement-bar');
    var btn = bar ? bar.querySelector('.announcement-bar__dismiss') : null;
    if (!bar || !btn) return;

    btn.addEventListener('click', function() {
      bar.classList.add('is-dismissed');
      // Store dismissal for this session
      try { sessionStorage.setItem('announcement-dismissed', '1'); } catch(e) {}
    });

    // Restore dismissed state
    try {
      if (sessionStorage.getItem('announcement-dismissed') === '1') {
        bar.classList.add('is-dismissed');
      }
    } catch(e) {}
  }

  /* ------------------------------------------
     Scroll-Reveal (IntersectionObserver)
     ------------------------------------------ */
  function initScrollReveal() {
    var targets = document.querySelectorAll('.reveal, .reveal-stagger');
    if (!targets.length) return;

    // Skip if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: CONFIG.observerThreshold,
      rootMargin: CONFIG.observerRootMargin
    });

    targets.forEach(function(el) { observer.observe(el); });
  }

  /* ------------------------------------------
     Collapsible Sections
     ------------------------------------------ */
  function initCollapsibles() {
    var triggers = document.querySelectorAll('.collapsible__trigger');

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var content = this.nextElementSibling;
        var isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', !isExpanded);
        content.classList.toggle('is-open');
      });
    });
  }

  /* ------------------------------------------
     Variant Selector
     ------------------------------------------ */
  function initVariantSelector() {
    var options = document.querySelectorAll('.variant-selector__option');

    options.forEach(function(option) {
      option.addEventListener('click', function() {
        if (this.classList.contains('is-unavailable')) return;

        // Deselect siblings
        var siblings = this.parentElement.querySelectorAll('.variant-selector__option');
        siblings.forEach(function(s) { s.classList.remove('is-selected'); });

        this.classList.add('is-selected');

        // Update hidden variant input if present
        var variantId = this.dataset.variantId;
        var form = this.closest('form');
        if (form && variantId) {
          var input = form.querySelector('input[name="id"]');
          if (input) input.value = variantId;

          // Update price display
          var priceEl = document.querySelector('.product-page__price');
          if (priceEl && this.dataset.price) {
            priceEl.textContent = this.dataset.price;
          }
        }
      });
    });
  }

  /* ------------------------------------------
     Quantity Selector
     ------------------------------------------ */
  function initQuantitySelector() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      var input = selector.querySelector('.quantity-selector__input');
      var minusBtn = selector.querySelector('[data-action="decrease"]');
      var plusBtn = selector.querySelector('[data-action="increase"]');

      if (!input) return;

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          var current = parseInt(input.value) || 1;
          var min = parseInt(input.min) || 0;
          if (current > min) input.value = current - 1;

          // Auto-submit cart form if on cart page
          var cartForm = selector.closest('form[action="/cart"]');
          if (cartForm) cartForm.submit();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          var current = parseInt(input.value) || 1;
          input.value = current + 1;

          // Auto-submit cart form if on cart page
          var cartForm = selector.closest('form[action="/cart"]');
          if (cartForm) cartForm.submit();
        });
      }
    });
  }

  /* ------------------------------------------
     Product Image Gallery
     ------------------------------------------ */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-page__thumb');
    var mainImage = document.querySelector('.product-page__main-image');

    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImage.src = this.dataset.fullSrc || this.src;
        mainImage.alt = this.alt;

        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  /* ------------------------------------------
     Image Zoom on Product Page
     ------------------------------------------ */
  function initImageZoom() {
    var wrappers = document.querySelectorAll('.product-page__image-wrapper, .product-full-width__image-wrapper');
    wrappers.forEach(function(wrapper) {
      wrapper.addEventListener('mousemove', function(e) {
        var rect = wrapper.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width * 100);
        var y = ((e.clientY - rect.top) / rect.height * 100);
        var img = wrapper.querySelector('img');
        if (img) {
          img.style.setProperty('--zoom-x', x + '%');
          img.style.setProperty('--zoom-y', y + '%');
        }
      });
      wrapper.addEventListener('mouseleave', function() {
        var img = wrapper.querySelector('img');
        if (img) {
          img.style.setProperty('--zoom-x', 'center');
          img.style.setProperty('--zoom-y', 'center');
        }
      });
    });
  }

  /* ------------------------------------------
     UX FIX [Interactions]: AJAX Cart with loading
     state and success confirmation
     ------------------------------------------ */
  function initAjaxCart() {
    var forms = document.querySelectorAll('form[action="/cart/add"]');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var btn = form.querySelector('.btn[type="submit"]');
        var originalText = btn ? btn.textContent.trim() : '';
        var formData = new FormData(form);

        // Loading state
        if (btn) {
          btn.classList.add('is-loading');
          btn.textContent = '';
        }

        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          // Update cart count
          updateCartCount();

          // Open cart drawer if enabled
          var cartType = (window.theme && window.theme.cartType) || 'page';
          if (cartType === 'drawer' && window.theme.refreshCartDrawer) {
            window.theme.refreshCartDrawer();
            if (btn) {
              btn.classList.remove('is-loading');
              btn.textContent = originalText;
            }
            setTimeout(function() {
              if (window.theme.openCartDrawer) window.theme.openCartDrawer();
            }, 150);
          } else {
            // Success state (page cart mode)
            if (btn) {
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              btn.textContent = strings.addedToCart || 'Added';

              setTimeout(function() {
                btn.classList.remove('is-added');
                btn.textContent = originalText;
              }, CONFIG.addedConfirmationMs);
            }
          }
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          if (btn) {
            btn.classList.remove('is-loading');
            btn.textContent = originalText;
          }
        });
      });
    });
  }

  function updateCartCount() {
    fetch(cartRoot + 'cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var countEl = document.querySelector('.site-header__cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        // Announce to screen readers
        var statusEl = document.getElementById('cart-status');
        if (statusEl) {
          statusEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ' in cart';
        }
      });
  }

  /* ------------------------------------------
     UX FIX [Product Page]: Sticky ATC bar on mobile
     Shows when the main ATC button scrolls out of view
     ------------------------------------------ */
  function initStickyATC() {
    var stickyBar = document.querySelector('.sticky-atc');
    var mainBtn = document.querySelector('.product-page .btn[type="submit"]');

    if (!stickyBar || !mainBtn) return;

    var isVisible = false;

    function checkVisibility() {
      var rect = mainBtn.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;

      if (shouldShow !== isVisible) {
        isVisible = shouldShow;
        stickyBar.classList.toggle('is-visible', isVisible);
        stickyBar.setAttribute('aria-hidden', !isVisible);
      }
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility();

    // Wire up sticky ATC button
    var stickyBtn = stickyBar.querySelector('.btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        mainBtn.click();
      });
    }
  }

  /* ------------------------------------------
     Cart Drawer
     ------------------------------------------ */
  function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var panel = drawer.querySelector('.cart-drawer__panel');
    var closeButtons = drawer.querySelectorAll('[data-cart-drawer-close]');
    var toggleButtons = document.querySelectorAll('.js-cart-drawer-toggle');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      // Focus the close button
      var closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    // Toggle buttons (header cart icon)
    toggleButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    // Close buttons (overlay + X button)
    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Drawer quantity buttons
    drawer.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest('[data-drawer-qty]');
      var removeBtn = e.target.closest('[data-drawer-remove]');

      if (qtyBtn) {
        var line = parseInt(qtyBtn.dataset.line);
        var input = qtyBtn.parentElement.querySelector('.quantity-selector__input');
        var current = parseInt(input.value) || 1;
        var newQty = qtyBtn.dataset.drawerQty === 'increase' ? current + 1 : current - 1;
        if (newQty < 0) newQty = 0;
        updateDrawerLine(line, newQty);
      }

      if (removeBtn) {
        var removeLine = parseInt(removeBtn.dataset.drawerRemove);
        updateDrawerLine(removeLine, 0);
      }
    });

    function updateDrawerLine(line, quantity) {
      fetch(cartRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        refreshDrawer();
        updateCartCount();
      });
    }

    // Expose openDrawer globally for AJAX cart integration
    window.theme = window.theme || {};
    window.theme.openCartDrawer = openDrawer;
    window.theme.refreshCartDrawer = refreshDrawer;

    function refreshDrawer() {
      fetch('/?section_id=cart-drawer')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var newBody = temp.querySelector('#cart-drawer-body');
          var newFooter = temp.querySelector('.cart-drawer__footer');
          var newCount = temp.querySelector('.cart-drawer__count');
          var currentBody = drawer.querySelector('#cart-drawer-body');
          var currentFooter = drawer.querySelector('.cart-drawer__footer');
          var currentCount = drawer.querySelector('.cart-drawer__count');
          if (currentBody && newBody) currentBody.innerHTML = newBody.innerHTML;
          if (currentFooter && newFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          } else if (currentFooter && !newFooter) {
            currentFooter.remove();
          }
          if (currentCount && newCount) currentCount.textContent = newCount.textContent;
        });
    }
  }

  /* ------------------------------------------
     Copy URL (share button)
     ------------------------------------------ */
  function initCopyUrl() {
    document.querySelectorAll('[data-copy-url]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var url = window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function() {
            showCopyFeedback(btn);
          });
        } else {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          showCopyFeedback(btn);
        }
      });
    });
  }

  function showCopyFeedback(btn) {
    var original = btn.textContent;
    btn.textContent = 'Copied!';
    setTimeout(function() { btn.textContent = original; }, 2000);
  }

  /* ------------------------------------------
     Recently Viewed Products
     ------------------------------------------ */
  function initRecentlyViewed() {
    var KEY = 'gf:recently-viewed';
    var MAX = 10;

    // Track current product
    var productMeta = document.querySelector('[data-product-handle]');
    if (productMeta) {
      var handle = productMeta.getAttribute('data-product-handle');
      if (handle) {
        var items = getRecentlyViewed();
        items = items.filter(function(h) { return h !== handle; });
        items.unshift(handle);
        if (items.length > MAX) items = items.slice(0, MAX);
        try { localStorage.setItem(KEY, JSON.stringify(items)); } catch(e) {}
      }
    }

    // Render recently viewed grid
    var container = document.querySelector('[data-recently-viewed]');
    if (!container) return;

    var handles = getRecentlyViewed();
    // Exclude current product if we're on a product page
    if (productMeta) {
      var currentHandle = productMeta.getAttribute('data-product-handle');
      handles = handles.filter(function(h) { return h !== currentHandle; });
    }

    if (handles.length === 0) {
      container.style.display = 'none';
      return;
    }

    var maxShow = parseInt(container.getAttribute('data-max') || '4', 10);
    handles = handles.slice(0, maxShow);

    // Fetch each product card via Section Rendering API
    var grid = container.querySelector('.recently-viewed__grid');
    if (!grid) return;

    handles.forEach(function(handle) {
      fetch('/products/' + handle + '?section_id=product-card-ajax')
        .then(function(r) { return r.ok ? r.text() : ''; })
        .then(function(html) {
          if (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var card = tmp.querySelector('.product-card');
            if (card) grid.appendChild(card);
          }
        })
        .catch(function() {});
    });
  }

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem('gf:recently-viewed') || '[]');
    } catch(e) { return []; }
  }

  /* ------------------------------------------
     Mega Menu (desktop hover/focus, mobile accordion)
     ------------------------------------------ */
  function initMegaMenu() {
    var megaItems = document.querySelectorAll('.nav-item--mega');
    if (!megaItems.length) return;

    megaItems.forEach(function(item) {
      var trigger = item.querySelector('.nav-item__link');
      var panel = item.querySelector('.mega-menu');
      if (!trigger || !panel) return;

      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      // Keyboard: Enter/Space toggles, Escape closes
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          panel.style.display = expanded ? 'none' : 'block';
        }
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.display = 'none';
          trigger.focus();
        }
      });

      // Close on Escape from within panel
      panel.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.display = 'none';
          trigger.focus();
        }
      });

      // Desktop: mouse events handle via CSS :hover, update aria for consistency
      item.addEventListener('mouseenter', function() {
        trigger.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function() {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ------------------------------------------
     Initialize Everything
     ------------------------------------------ */
  function init() {
    initMobileMenu();
    initStickyHeader();
    initAnnouncementDismiss();
    initScrollReveal();
    initCollapsibles();
    initVariantSelector();
    initQuantitySelector();
    initProductGallery();
    initImageZoom();
    initAjaxCart();
    initStickyATC();
    initCartDrawer();
    initCopyUrl();
    initRecentlyViewed();
    initMegaMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
